import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  CharacterLimitation,
  LimitSpoofFeature
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CharacterLimitationBox from "@dndComponents/limitations/CharacterLimitationBox";
import { DisablableOption } from "@models";

interface Props {
  obj: LimitSpoofFeature;
  onChange: (changed: LimitSpoofFeature) => void; 
  disabled: boolean;
}

export default function LimitSpoofFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);

  const options: DisablableOption[] = [
    { id: "item", text: "Item" },
    { id: "subrace", text: "Subrace/Lineage" },
    { id: "subclass", text: "Subclass" },
    { id: "eldritch_invocation", text: "Eldritch Invocation" },
    { id: "feat", text: "Feat" },
    { id: "game_class", text: "Class" }
  ];
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Override Limits From"
          options={options}
          values={obj.limits_for}
          multiple
          disabled={disabled}
          onChange={(changed: string[]) => {
            obj.limits_for = changed;
            onChange(obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <CharacterLimitationBox
          obj={obj.limit_spoof}
          disabled={disabled}
          types={["race","subrace","game_class","subclass","gift","pact_boon","eldritch_invocation"]}
          onChange={(changed: CharacterLimitation) => {
            obj.limit_spoof.copy(changed);
            onChange(obj);
            setPing(!ping);
          }}
        />
      </Grid>
    </Grid>
  );
}
